import { atomFamily } from 'jotai/utils';
import { Atom } from 'jotai/vanilla';
import { AtomFamily } from 'jotai/vanilla/utils/atomFamily';
import { nodePendingQueue } from 'shared/utils/node-pending-queue';

export const safeAtomFamily = <Param, AtomType extends Atom<unknown>>(
  initializeAtom: (param: Param) => AtomType,
  areEqual?: (a: Param, b: Param) => boolean,
): AtomFamily<Param, AtomType> => {
  let family: AtomFamily<Param, AtomType> | null = null;

  const initializeAtomWrapper = (param: Param): AtomType => {
    const atom = initializeAtom(param);
    if (typeof window === 'undefined') {
      nodePendingQueue.push(() => {
        family?.remove(param);
      });
    }

    return atom;
  };

  family = atomFamily(initializeAtomWrapper, areEqual);

  return family;
};
